import * as React from 'react';
import { useEffect } from 'react';
import { useRouter } from 'next/router';

const stateLinks: { [key: string]: string } = {
  AZ: 'az-arizona',
  CA: 'ca-california',
  CO: 'co-colorado',
  CT: 'ct-connecticut',
  CTB: 'ct-connecticut',
  CTL: 'ct-connecticut',
  DC: 'dc-washington-dc',
  DCB: 'dc-washington-dc',
  DCL: 'dc-washington-dc',
  DE: 'de-delaware',
  DEB: 'de-delaware',
  DEL: 'de-delaware',
  GA: 'ga-georgia',
  FL: 'fl-florida',
  ID: 'id-idaho',
  IL: 'il-illinois',
  IA: 'ia-iowa',
  IN: 'in-indiana',
  KS: 'ks-kansas',
  KY: 'ky-kentucky',
  LA: 'la-louisiana',
  MD: 'md-maryland',
  MDB: 'md-maryland',
  MDL: 'md-maryland',
  ME: 'me-maine',
  MA: 'ma-massachusetts',
  MAB: 'ma-massachusetts',
  MAL: 'ma-massachusetts',
  MI: 'mi-michigan',
  MO: 'mo-missouri',
  MN: 'mn-minnesota',
  MS: 'ms-mississippi',
  NV: 'nv-nevada',
  NC: 'nc-northcarolina',
  NH: 'nh-newhampshire',
  NHB: 'nh-newhampshire',
  NHL: 'nh-newhampshire',
  NJ: 'nj-new-jersey',
  NJB: 'nj-new-jersey',
  NJL: 'nj-new-jersey',
  NM: 'nm-new-mexico',
  NY: 'ny-new-york',
  OH: 'oh-ohio',
  OK: 'ok-oklahoma',
  OR: 'or-oregon',
  PA: 'pa-pennsylvania',
  RI: 'ri-rhode-island',
  RIB: 'ri-rhode-island',
  RIL: 'ri-rhode-island',
  SC: 'sc-south-carolina',
  UT: 'ut-utah',
  TN: 'tn-tennessee',
  TX: 'tx-texas',
  VA: 'va-virginia',
  VT: 'vt-vermont',
  VTB: 'vt-vermont',
  VTL: 'vt-vermont',
  WA: 'wa-washington',
  WI: 'wi-wisconsin',
};

const UsaMap = () => {
  const router = useRouter();

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const id = (e.target as SVGElement)?.getAttribute('id');
      if (id && stateLinks[id]) {
        router.push(`/home-battery-solar-installers-near-me/${stateLinks[id]}`);
      }
    };

    window.addEventListener('click', handleClick);

    return () => {
      window.removeEventListener('click', handleClick);
    };
  }, [router]);

  return <SvgComponent />;
};

export default UsaMap;

type SvgComponentProps = {
  viewBox?: string;
  style?: React.CSSProperties;
};

const SvgComponent = (props: SvgComponentProps) => {
  const { viewBox = '100 0 1167 589', style = {}, ...rest } = props;
  return (
    <svg
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      id="svg"
      width="100%"
      style={{
        strokeLinejoin: 'round',
        stroke: '#dcdde1',
        fill: 'none',
        ...style,
      }}
      {...rest}
    >
      <defs id="defs4">
        <style id="style6" type="text/css">
          {'path{fill-rule:evenodd}'}
        </style>
      </defs>
      <path
        id="MA"
        d="m956.312 153.05-.291-.193v.29l.29-.096zm-2.912-2.62.68-.291v-.388l-.68.68zm12.036-7.57-.097-1.36-.194-.776.29 2.135zm-42.417-9.998-.68.29-5.532 1.651-1.941.68-2.233.679-.776.291v.291l.291 5.048.291 4.659.291 4.27.486.292 1.747-.486 7.862-2.33.194.486 13.977-5.338.097.194 1.262-.486 4.465-1.747 4.27 5.145.583-.486.291-1.456-.097 2.33h.97l.292 1.165.874 1.65 4.562-5.533 3.785 1.262.874-1.941 6.212-3.3-2.621-5.145.68 3.3-3.204 2.427-3.591.291-7.183-7.668-3.203-4.853 3.203-3.397-3.3-.194-1.359-3.204-.097-.194-5.532 6.018-12.23 4.077-3.98 1.262z"
        data-id="MA"
        data-name="Massachusetts"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="MN"
        d="m558.547 73.847 1.941 6.892 4.077 24.848 1.941 9.9.583 8.736 2.232 5.242.485 4.464.389 1.456-.097.292-3.883 6.406 2.524 4.27 4.853 34.167.194 4.465 4.853-.292 19.122-1.067 47.755-3.98 4.756-.485v-.485l-1.36-7.474-5.92-3.01-4.659-4.852-7.377-4.465-2.33-.194-3.59-2.718.97-13.395-3.397-3.106 1.164-5.436 6.213-5.63-1.068-11.647 2.232-2.523 7.571-7.96 8.639-11.065 3.3-2.33 5.824-2.814 6.115-4.562-4.077.776-2.426-1.844-9.319 1.262-1.455-1.747-8.348 3.397-6.697-2.815-1.844-2.232-5.339.388-3.591-1.844 1.164-1.359-4.561-1.456h-4.077l-6.503 2.815-1.262-1.941-10.289-1.456-3.494-8.736-.388-2.62-4.465-1.263.388 7.474-11.842.874-14.656.582-.97.097z"
        data-id="MN"
        data-name="Minnesota"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="MT"
        d="m465.658 72.974-32.128-2.136-23.392-2.232-23.296-2.718-14.462-1.941-23.101-3.591-11.55-1.942-25.82-4.95-2.717-.582-4.174 19.8 1.844 3.592 1.456 5.533-.873.776 1.844 5.047 2.524 2.136 7.182 12.036.68 2.038 2.912-.194-3.398 15.918-1.358.388-1.845 5.339 9.61.68.776 4.464 5.436 13.298.97.776 3.786 7.765.97-.776 8.057-.097 10.191 1.067 2.524-3.3 3.009 5.436.582.291.097-.582 1.36-9.513 33.195 4.077 26.498 2.524 13.977 1.165 24.945 1.455 1.262.098h.291l.097-1.36.292-6.697.388-8.832.097-2.233.194-3.882 1.553-30.478 1.262-23.684.097-3.882-1.844-.097z"
        data-id="MT"
        data-name="Montana"
        style={{
          strokeWidth: 0.97063118,
          fill: '#f9f9f9',
        }}
      />
      <path
        id="ND"
        d="m556.509 73.847-29.313.583-20.48-.097-17.569-.389-20.577-.776-1.068-.097-.097 3.882-1.262 23.684-1.553 30.478-.194 3.882 3.785.194 42.805 1.165 39.505-.291 16.404-.486 3.3-.194-.389-1.456-.485-4.464-2.232-5.242-.583-8.736-1.941-9.9-4.077-24.848-1.94-6.892h-2.04z"
        data-id="ND"
        data-name="North Dakota"
        style={{
          strokeWidth: 0.97063118,
          fill: '#f9f9f9',
        }}
      />
      {/* <path
        id="HI"
        d="m416.35 515-3.01-2.233-2.62.68.582 5.435-3.591 4.465 3.106 7.085.874 7.28 3.59 2.33 2.233-3.592 3.98-2.912 4.853-1.262 5.339-4.561-5.242-4.465-.097-2.718-9.997-5.533zm-17.666-7.863-1.456-1.262-1.359 1.845 2.815-.583zm-7.28-4.174.389-3.59-1.845-.292 1.456 3.882zm6.115-5.92-1.65.776 1.165 3.688 2.524.195.776 3.203 2.718 1.164 6.018-2.814-5.63-4.66-5.92-1.552zm-12.424-3.98-.873 2.62 4.173-.096 3.883.97-2.038-3.203-5.145-.291zm-12.23-7.668-2.232-2.135-4.27 3.3 2.717 5.047 1.941-2.038 5.533 1.164-.486-2.33-3.203-3.008zm-43.484-4.27.582-1.36 1.65-.873-2.232 2.232zm15.433-8.834-6.794 2.524-.68 1.844 2.718 1.942 3.786.97 2.717-5.338-1.747-1.942zm-47.075-17.86v-.096h-.195l.195.097zm-51.444-12.714v.194h.097l-.097-.194zm-26.983-4.465.097.097-.097-.097zm-1.068-1.942zm-.874-.97h-.194v.097l.194-.097zm.68 0h-.097.097zm-.097-.097v.097-.097zM187.475 409.2l-.097-.29v.096l.097.194zm-66.488-21.256-.292.29.194.098.098-.388zm-70.371-49.017zm2.426.097h-.097.097zm-.485-.097zm-41.446-18.151.291-.097v-.194l-.29.29z"
        data-id="HI"
        data-name="Hawaii"
        style={{
          strokeWidth: 0.97063118,
          fill: '#f9f9f9',
        }}
      /> */}
      <path
        id="ID"
        d="m309.095 52.882-8.639-1.747-2.815-.68-1.261-.291-11.26 50.667.486 4.174-.389 4.367.195.971v.097l.097 1.844 3.3 3.592-4.756 11.938-10.095 13.201-.291 2.427 2.62 6.212-9.22 38.243-.389 2.038 2.718.582 27.469 5.436 10.968 2.038 2.815.485 2.718.486 13.977 2.232 25.042 3.786 2.815.388.388-3.203.874-6.31 3.3-25.236 1.747-12.52.388-3.204-.582-.291-3.01-5.436-2.523 3.3-10.191-1.067-8.057.097-.97.776-3.786-7.765-.97-.776-5.436-13.298-.776-4.465-9.61-.68 1.845-5.338 1.358-.388 3.398-15.918-2.912.194-.68-2.038-7.182-12.036-2.524-2.136-1.844-5.047.873-.776-1.456-5.533-1.844-3.591 4.174-19.801h-.097z"
        data-id="ID"
        data-name="Idaho"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="WA"
        d="m192.134 77.05.097-1.65-.194.097.097 1.553zm20.674-8.832.583-.97-.68-.098.097 1.068zm-1.844-1.747.582-1.942-.582-.194v2.136zm7.086-2.815-.097-1.942-1.65 2.524 1.747-.582zm.194-4.077.291-1.941-.194-.486-.097 2.427zm.291-9.512-.097-1.068-.388-.097.485 1.165zm3.106-6.406-.874-.097-1.747 2.717 2.621-2.62zm-2.427-2.621.486-.388.097-.291-.583.679zm-.485.291-.291-1.941-.874 1.65 1.165.291zm-.485-2.718-.874-.388.68.97.194-.582zm2.912 1.65v-1.261l-.291.485.29.777zm.873-1.261-.388-.292h-.097l.485.292zm-5.532-2.136-.486-.388-.194-.097.68.485zm3.591-.388-2.62.68.679.194 1.941-.874zm-2.135-.194-.486-.582-.097.097.583.485zm2.038-1.165h-.388l.485.194-.097-.194zm-19.024 49.794 3.494 3.785-.583 7.28.68 1.844 5.241 2.815 14.754 1.359.582 1.747 6.989.097 6.6.873 10.774-1.164 5.339.873 1.456-.68 27.274 6.213 1.845.388-.195-.97.389-4.368-.486-4.174 11.26-50.667-1.553-.291-22.713-5.339-19.801-5.047-22.422-6.212-6.697-1.65 1.553 8.444-1.456 2.718-2.62-1.359 2.523 11.745-2.718 3.882-1.262 3.592v3.688l-5.726 3.98-2.427-1.553-2.33 1.165 4.271-5.533-1.067 3.785 2.426-2.62 1.942.388-.583-4.853 1.262.194 2.62-5.824-.873-.873-3.397 4.367-2.233.097 2.427-2.717 2.718-.68-.97-4.95-2.719-.68-1.358-2.329-1.65.874-8.93-3.883-7.862-6.115-2.136 5.921-.194 2.524 1.65 4.465-1.068 14.462-.776 2.232 4.368.389-4.368 3.106 2.33 1.164-1.845 6.212-.873-4.853-1.65 5.63 2.232 2.718 2.427-.194 2.912 1.747 1.455 2.815h1.748z"
        data-id="WA"
        data-name="Washington"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="AZ"
        d="m372.186 309.905-32.71-4.077-17.569-2.523-25.042-3.98-2.524-.388v.194l-4.27 18.83-2.233-.097-3.397-3.009-4.27 3.591-.098 15.433-1.553 3.3v.389l-.194 2.426 3.397 9.124 3.009 4.077-5.436 3.203-2.135 3.98-3.494 8.541-1.747.388-.097 7.086 3.009 2.233-1.553 4.27-3.495.194-2.038 3.786 6.988 4.368 13.201 7.377 40.767 21.645 34.554 4.27h.388l2.718-28.633.68-7.086 7.28-75.127.387-3.494-2.523-.291z"
        data-id="AZ"
        data-name="Arizona"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="CA"
        d="m206.014 363.775.388 2.135v.389l-.388-2.524zm-14.268-8.348.679 1.456.388-.097-1.067-1.359zm16.986-.29.29 2.523 1.748 1.262-2.038-3.786zm-11.745-13.784-1.068-.29.874.387.194-.097zm-10.774-2.912-2.62 1.553.679.68 1.941-2.233zm-5.047-1.844-.194.777.873.194-.68-.97zm8.541 1.941 4.271 2.427.777-.68-5.048-1.747zm-33.098-85.512-.097.097.097-.097zm10.385.485-.097-.291v.388l.097-.097zM223 179.841l-3.786-.971-41.543-11.454-15.433-4.659v.388l-.873 9.61-4.077 11.356-6.794 8.445-.194 4.27 3.3 5.921 1.65 7.765-2.33 6.31.389 6.308-1.165 2.621 3.98 8.639 2.523 3.3-.194 9.415 6.018 5.727 3.494-5.824 3.786 3.009 1.456-1.359-5.242.97-.097 4.95 1.068 6.213-2.912-2.815-1.65-3.785-.486 5.241 1.36 10.386 5.435 6.697-3.591 4.66.582 5.92 3.882 6.018 6.795 18.636 2.135 1.165-.68 12.91 1.068 1.552 14.56 5.242 4.465 4.756 1.553 3.106 4.27 2.426 4.66.874 1.94 5.338 3.883 1.845 5.824 6.891 5.436 9.027-.388 8.347 3.008 3.98 39.7 3.882 3.494-.194 1.553-4.27-3.01-2.233.098-7.086 1.747-.388 3.494-8.541 2.136-3.98 5.435-3.203-3.009-4.077-3.397-9.124.194-2.426v-.097l-2.524-3.397-7.765-10.386-15.044-21.16-20.966-30.09-11.842-16.403-11.453-16.5 13.2-56.006.874-3.689z"
        data-id="CA"
        data-name="California"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="CO"
        d="m489.632 255.55.389-19.025-4.66-.194-23.683-.874-2.33-.097-1.94-.097-28.828-1.844-19.219-1.553-23.974-2.33-2.33-.29-.291 2.523-5.242 50.57-1.844 17.665-.776 7.668-.194 2.524 3.009.291 48.92 4.27 21.547 1.36 21.451.97 3.106.098 1.942.097 4.076.097 1.941.097 6.115.194h1.553v-1.941l1.068-51.347.097-5.726v-1.845l.097-1.261z"
        data-id="CO"
        data-name="Colorado"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="NV"
        d="m294.827 295.83 10.094-62.8 5.145-31.448.582-3.106-2.815-.485-10.968-2.038-27.469-5.436-2.718-.582-2.717-.583-13.686-3.008-24.557-5.824-2.718-.68-.874 3.689-13.2 56.005 11.453 16.5 11.842 16.404 20.966 30.09 15.044 21.16 7.765 10.386 2.524 3.397v-.291l1.553-3.3.097-15.434 4.27-3.59 3.398 3.008 2.233.097 4.27-18.83v-.194l.486-3.106z"
        data-id="NV"
        data-name="Nevada"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="NM"
        d="m472.452 324.756.097-2.524.097-2.524.097-2.523-3.106-.098-21.45-.97-21.549-1.359-48.92-4.27-3.008-.292-.389 3.494-7.28 75.127-.679 7.086-2.718 28.633.389.097 13.394 1.262 1.262-6.794 2.427-1.941 27.178 2.426h.194l-2.427-4.756 12.327.874 30.77 1.747 19.218.873 3.3-91.045.68.097.096-2.62z"
        data-id="NM"
        data-name="New Mexico"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="OR"
        d="m162.238 162.757 15.433 4.66 41.543 11.453 3.786.97 2.718.68 24.557 5.824 13.686 3.008 2.717.583.389-2.038 9.22-38.243-2.62-6.212.291-2.427 10.095-13.2 4.756-11.94-3.3-3.59-.098-1.845v-.097l-1.844-.388-27.274-6.212-1.456.68-5.339-.874-10.774 1.164-6.6-.873-6.989-.097-.582-1.747-14.754-1.36-5.241-2.814-.68-1.844.583-7.28-3.494-3.786-.292.098-.68.485-4.852-2.524-2.912.874-1.941-.97-2.039 8.347-1.359 2.33-6.018 14.656-1.747 8.056-1.067.097-5.63 13.395-3.785 5.726-1.36.971-3.494 6.794-.68 7.183-2.134 6.406 1.261 5.824v.097zm35.526-79.689-.292-.873-.097.68.388.193z"
        data-id="OR"
        data-name="Oregon"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="UT"
        d="m352.385 204.98-25.042-3.786-13.977-2.232-2.718-.486-.582 3.106-5.145 31.449-10.094 62.8-.486 3.106 2.524.388 25.042 3.98 17.569 2.523 32.71 4.077 2.524.291.194-2.524.776-7.668 1.844-17.665 5.242-50.57.291-2.524-1.941-.194-24.751-3.009-3.786-.485 2.427-18.927.194-1.262-2.815-.388z"
        data-id="UT"
        data-name="Utah"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="WY"
        d="m461.387 192.167.776-15.142.971-20.383.097-2.523-1.262-.098-24.945-1.455-13.977-1.165-26.498-2.524-33.196-4.077-1.359 9.513-.097.582-.388 3.203-1.747 12.521-3.3 25.237-.874 6.309-.388 3.203-.194 1.262-2.427 18.927 3.786.485 24.75 3.01 1.942.193 2.33.292 23.974 2.33 19.219 1.552 28.827 1.844 1.942.097.097-2.523.485-10.192.874-17.762.388-7.571.097-2.524.097-2.62z"
        data-id="WY"
        data-name="Wyoming"
        style={{
          strokeWidth: 0.97063118,
          fill: '#f9f9f9',
        }}
      />
      <path
        id="AR"
        d="m690.456 328.056-10.483 1.553 4.27-6.795-1.843-3.785-36.981 3.591-31.255 2.524-4.562.291.583 2.718 3.785 19.606.097 4.368 1.068 26.401.097 4.368.291.097 1.456 1.553 5.824-.194.582 8.542.194 2.426 3.01-.29 9.22-.68 36.593-3.397h.194l-.097-2.136.97-.68-1.746-3.3 3.688-15.53-1.456-1.747 5.533-6.115-.388-5.241 4.076-6.794v-.098l-.194-.194 3.494-3.203-.97-3.882 2.717-4.271-.582-3.98 2.912-5.63v-.096h-.097z"
        data-id="AR"
        data-name="Arkansas"
        style={{
          strokeWidth: 0.97063118,
          fill: '#f9f9f9',
        }}
      />
      <path
        id="IA"
        d="m661.531 197.7-5.338-2.815-2.912-3.98-.97-5.726.776-2.621-2.815-3.397-4.756.485-47.755 3.98-19.122 1.067-4.853.292-2.038.097 1.65 10.774-1.36 5.144 2.136 3.203v.68l.68.097 3.106 9.124 3.009 4.756.194 5.435 3.3 4.562-.582 1.941 3.009 12.23v.292l19.897-.583 21.257-1.844 20.869-2.62 4.756 4.173.194.194.874-.388-.68-3.786 3.592-2.232 1.456-9.9-1.456-.68.873-5.047 4.368-.874 4.853-3.494 2.136-6.115.097-3.106-3.883-3.688-1.165-2.33-3.688-2.33.194-.485.097-.485z"
        data-id="IA"
        data-name="Iowa"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="KS"
        d="m608.923 312.72-2.427-41.058-4.368-2.524-.388-1.94-3.494-3.107 3.397-4.174-1.359-2.426-2.523.097-2.33-1.65-.97-.777-3.3.194-35.817 1.36-16.404.388h-32.613l-13.103-.195-3.689-.097v1.845l-.097 5.726-1.068 51.347v1.94l4.174.098 22.519.291 52.705-.776 37.563-1.747 3.689-.292-.097-2.523z"
        data-id="KS"
        data-name="Kansas"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="MO"
        d="m653.669 242.446-4.756-4.174-20.869 2.621-21.257 1.844-19.897.583-.098.582 2.427 4.659 2.232 1.553 2.621 4.659.388.388.971.777 2.33 1.65 2.523-.097 1.36 2.426-3.398 4.174 3.494 3.106.388 1.941 4.368 2.524 2.427 41.058.097 2.523.194 2.524.097 2.524.194 2.62.097 2.524 4.562-.291 31.255-2.524 36.98-3.591 1.845 3.785-4.27 6.795 10.482-1.553h.097v-.777l.194-4.465 1.941-2.426-.582-2.718-.097-.097-.097-.097.388-1.262.583.194.29.776-.096.292v.873l.388.097.776-.97v-.097l.097-.292 2.524-1.553.388-.194.874-7.959-.194-.388-.291-.097-6.892-5.63 1.068-2.038-1.941-5.533-3.495-2.718-6.6-2.911-4.174-3.398.486-6.988 1.261-6.503-6.988.388-2.136-2.233-.97-4.465-11.065-9.318-3.106-8.638.776-4.271-.194-.194z"
        data-id="MO"
        data-name="Missouri"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="NE"
        d="m572.33 204.688-3.009-3.009-10.58-3.106-3.397-.097-5.144 1.456-6.115-3.882-19.122.194-27.857-.291-32.904-1.068-2.912-.097-.097 2.524-.388 7.57-.874 17.763-.485 10.192-.097 2.523 2.329.097 23.683.874 4.66.194-.389 19.024-.097 1.262 3.689.097 13.103.195h32.613l16.404-.389 35.816-1.359 3.3-.194-.388-.388-2.62-4.659-2.233-1.553-2.427-4.66.097-.581v-.292l-3.008-12.23.582-1.94-3.3-4.563-.194-5.435-3.01-4.756-3.105-9.124-.68-.097-1.844-.195z"
        data-id="NE"
        data-name="Nebraska"
        style={{
          strokeWidth: 0.97063118,
          fill: '#f9f9f9',
        }}
      />
      <path
        id="OK"
        d="m609.505 322.911-.194-2.62-.097-2.524-.194-2.524-3.688.292-37.564 1.747-52.705.776-22.519-.291-4.174-.097h-1.553l-6.115-.194-1.94-.097-4.077-.097-1.942-.098-.097 2.524-.097 2.524-.097 2.523-.097 2.621h.582l23.49.582 24.848.292.29 33.195 1.748 5.824 3.883 3.688 4.173.195.874-1.748 5.727 5.242 7.473.776 1.36 1.553 2.717-1.262 6.794 3.204v1.844l2.524-.097 2.62-2.233 4.854 3.106 4.562 1.65 3.106-4.27 9.9 4.659 3.689-3.01 3.009-1.164 2.426.582 9.124-2.62 4.853 2.038 4.368 2.815 3.786.68h.097l-.097-4.369-1.068-26.4-.097-4.369-3.786-19.606-.582-2.718-.097-2.524z"
        data-id="OK"
        data-name="Oklahoma"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="SD"
        d="m566.895 135.58-16.404.485-39.505.291-42.805-1.165-3.785-.194-.097 2.233-.388 8.832-.292 6.698-.097 1.359h-.29l-.098 2.523-.97 20.383-.777 15.142-.097 2.621 2.912.097 32.904 1.068 27.857.291 19.122-.194 6.115 3.882 5.144-1.456 3.397.098 10.58 3.106 3.009 3.009 1.844.194v-.68L572.04 201l1.359-5.144-1.65-10.774 2.038-.097-.194-4.465-4.853-34.166-2.524-4.271 3.882-6.406.098-.292-3.3.195z"
        data-id="SD"
        data-name="South Dakota"
        style={{
          strokeWidth: 0.97063118,
          fill: '#f9f9f9',
        }}
      />
      <path
        id="LA"
        d="m689 469.283-1.262.29-.582.583 1.844-.874zm4.077 0-.68-.292-.194.292h.874zm2.33-.777h-.68l-.389.485 1.068-.485zm-1.166-.68-.194-.29-.097.29h.291zm7.765-5.144-.29.194h.485l-.195-.194zm13.59-5.727.582-.776-.68.874.097-.098zm1.94-2.523-.194.097v.097l.195-.194zm-49.89 8.541 1.456-1.844-3.98-1.067-1.747 1.455 4.271 1.456zm40.281-8.444-.388-.388-.097.194.485.194zm1.068-1.747-.97-.291.29.97.68-.68zm7.96-1.65v-.291V451.132zm1.94-1.262-.097-.097.097.194v-.097zm-.776-.194-.194-.097-.097.29.29-.193zm-6.795-.291.874-.292v-.29l-.874.582zm.486-.486.485-.485-.097-.097-.388.582zm-3.397-3.591-.195.194h.098l.097-.194zm-35.817-54.355h-.194l-36.593 3.397-9.22.68-3.01.29.098 2.33 1.94 18.733 3.204 4.465.097 2.62 3.106 5.436 2.524 7.96-.874 4.464-.68 11.066-1.455 3.59h.194l.291 2.524-1.65 2.33 12.036-1.359 9.415 2.62 6.697.874 3.397-2.426-1.844-2.427 6.212-1.941-.194 2.135 3.203-.776 2.62 4.077 2.233-.777 5.824 3.98-3.591 1.261 8.25 2.427h3.106l1.844-2.232 3.98-2.136 2.815 4.077 1.941-3.689-.582-5.823 5.241 2.038.583 1.747 6.212.777 3.106 2.523-.389 2.039 4.368-4.077-1.65-2.135-7.28-1.845-2.717-1.553-.098-2.912 3.01.389 2.329-4.756-3.009-4.174-1.65 3.98-3.786-.68 2.621-4.27-1.747-.486-4.27 3.009-6.116.388-1.747-1.359 2.815-4.95 3.3-.097 5.63 1.844 4.076.388-2.232-2.814-4.27-8.348 1.164-4.659-33.487 3.688 1.262-1.261-1.359-3.495 2.038-3.009 1.165-7.57 7.377-12.619-3.591-4.368.194-3.203-2.233-5.241v-.68z"
        data-id="LA"
        data-name="Louisiana"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="TX"
        d="m573.98 536.935-4.659-17.568v3.3l4.66 14.268zm-1.068-30.866-3.3 6.212-.388 2.039 3.688-8.25zm2.621-4.562 3.106-4.076-2.232 1.359-.874 2.717zm10.968-9.9-7.28 3.785 2.039-.388 5.241-3.397zm.97-1.359 2.04-1.65-.777.194-1.262 1.456zM472.356 327.376l-.68-.097-3.3 91.045-19.218-.873-30.769-1.747-12.327-.874 2.427 4.756.097.097 10.482 10.483 6.018 7.086 7.96 5.92 5.63 10.29 2.135 10.773 4.562 3.01 3.59 3.979 5.145 1.844 7.474 4.756 3.397 1.262 4.66-4.66 1.455-4.95 2.427-4.755 7.57-3.01 2.913 1.457 8.444.679 7.668 4.756 5.242.97-1.456 2.718 3.009 1.942 2.814 3.397.583 3.591 1.844 2.427 4.27 10.289 4.272 3.59 3.3 5.436 4.173 4.271 1.845.583 1.553 11.065 4.562 2.523.194 3.495 1.164-.292 7.96 9.707 3.98.873 5.047 3.01h7.765l5.63 3.105 6.697-1.456-3.01-2.814-2.717-8.154-1.068-7.085-1.553-2.33.68-4.756-2.039-.194-2.718-4.465 3.107 3.3 3.59-1.262 1.942-5.144-3.882-5.241 5.823.679 2.718-4.174-.388-1.456 2.426-3.203-.582 2.815 2.718-2.135-1.068-3.786 3.494 1.844 4.465-2.523-4.368-4.562 2.718 1.068 5.048.29 6.6-1.455 7.377-4.95 4.465-3.689.679-2.718 2.718-2.814-1.456-4.66.291-2.911 4.853-2.136-.388 5.145h2.912l-3.203 2.717 12.91-6.794 2.134-.097 1.36-6.212h.388l1.456-3.592.679-11.065.874-4.465-2.524-7.959-3.106-5.435-.097-2.621-3.203-4.465-1.942-18.733-.097-2.33-.194-2.426-.582-8.542-5.824.194-1.456-1.553-.291-.097h-.097l-3.786-.68-4.367-2.814-4.854-2.038-9.124 2.62-2.426-.582-3.01 1.165-3.687 3.009-9.9-4.66-3.107 4.271-4.562-1.65-4.853-3.106-2.62 2.233-2.524.097v-1.844l-6.795-3.203-2.718 1.261-1.358-1.553-7.474-.776-5.727-5.241-.874 1.747-4.173-.194-3.883-3.689-1.747-5.824-.291-33.195-24.848-.291-23.49-.583h-.582z"
        data-id="TX"
        data-name="Texas"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="CT"
        d="m936.996 143.345-13.977 5.338-.194-.485-7.862 2.33-1.747.485.194.97 3.688 14.268 1.165 1.456-2.524 3.106 1.748 1.65 5.63-5.435 3.008-4.174.583 1.165 14.17-6.31.292-.29-.097-2.33-.583-2.038-3.008-8.445-.389-1.067-.097-.194z"
        data-id="CT"
        data-name="Connecticut"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="NH"
        d="m923.893 75.983-1.262 1.553-1.456-.291-.777 6.406v.097l2.33 8.735-.194 1.748-4.174 5.532 1.068 5.047v6.31l-.777 5.823 4.368 15.919L927 131.6l12.23-4.077 5.532-6.018v-1.553l.291-2.523-.679.29-.097-.582-6.115-7.473-.194-.68-14.074-33.001z"
        data-id="NH"
        data-name="New Hampshire"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="RI"
        d="m946.508 152.08-.097-2.038-.29.776.387 1.262zm1.942-1.553-1.262-2.426-.097 2.523 1.359-.097zm-.583-3.009.68 1.747.873 1.553.583-1.164-.874-1.65-.291-1.165h-.97v.68zm-10.774-3.98.389 1.068 3.009 8.445.582 2.038.097 2.33.194-.291 4.66-3.689-.874-6.6 1.94-.388-4.27-5.145-4.465 1.747-1.262.486z"
        data-id="RI"
        data-name="Rhode Island"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="VT"
        d="m923.02 132.862-4.369-15.919.777-5.823v-6.31l-1.068-5.047 4.174-5.532.194-1.748-2.33-8.735-1.261.485-5.339 1.941-5.241 2.039-12.036 4.368-.68.194 4.368 10.191 1.456 9.61 5.145 8.056 4.853 15.918.194-.097.776-.291 2.233-.68 1.941-.68 5.533-1.65.68-.29z"
        data-id="VT"
        data-name="Vermont"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="AL"
        d="m718.313 344.848.388.776 1.36.874.582 39.796.194 21.839 4.95 29.895.388-.097 4.368.874 1.165-8.639 1.941 4.853 3.3 3.01 6.31-3.69-.68-.582.194.097-4.368-9.997 41.931-6.794 2.815-.486v-.097l-2.62-4.95-.195-7.086-2.135-3.882 1.068-7.571 1.747-1.941-7.183-12.813-13.006-39.601-.097-.195-2.912.486-15.53 2.523-7.765.971-16.307 2.232.097.195z"
        data-id="AL"
        data-name="Alabama"
        style={{
          strokeWidth: 0.97063118,
          fill: '#f9f9f9',
        }}
      />
      <path
        id="FL"
        d="M854.687 535.285h-.194l.097.098.097-.098zm-.874-.097v.097h.097l-.097-.097zm.194-.097v-.097.097zm-13.2 1.456v.097-.097zm-.194.097v-.097.097zm.097-.097zm-.971.097h-.097v.097l.097-.097zm27.566-6.115h-.097l.097.194v-.194zm2.62-.68v-.193l-.193.29.194-.096zm-.97-.193-.388-.389-.097.098.485.29zm-.291.776-1.165-1.456.68 1.262.485.194zm9.22-5.727v.389l.195-.194-.194-.195zm1.36-.97.29-.485-.387.388.097.097zm.29-.97h-.096v.096l.097-.097zm-1.746-.292-.097-.097.097.097zm.873-1.456-.097-.097v.194l.097-.097zm-2.62-.097-.097-.097.097.097zm3.3-2.232-.194.097.29.097-.096-.194zm.388 0-.194-.195.097.292.097-.097zm-.68-.195-.097-.097v.194l.098-.097zm3.592-.679v-.097l-.194.388.194-.291zm-4.077.388h-.194l.194.097v-.097zm2.039-1.165h-.292l-.097.098.389-.098zm.776-.485h-.097.097zm-8.153.388v-.194l-.097.194h.097zm.873-.29h-.29l.29.582v-.583zm-2.33.096v-.582l-.484.097.485.485zm-1.358-.97.485.485v-.194l-.485-.291zm14.268.582-1.747.777.582.097 1.165-.874zm-13.589-.874h-.582v.195l.582-.195zm15.336-4.853.097-.485.098-1.262-.195 1.747zm.097-5.435-.388-.97-.194.387.582.583zm-22.421 2.426-.194.292.485.097-.291-.389zm-1.844-.873-.874.291.68.097.194-.388zm-1.942.194v-.291l-.097.097.097.194zm-2.038-.097-.582.388.776.388-.194-.776zm2.718.097-.097-.291-.486-.097.583.388zm-12.715-9.512-.583.29 1.165.39-.582-.68zm-2.33-3.106-.776-1.165.29.874.486.29zm3.009 1.941-1.359-3.106-.97-.291 2.329 3.397zm-3.882-3.883-.292-.776-.194-.485.486 1.261zm-8.057-10.774-1.747-1.261.68.68 1.067.581zm43.679-6.503-7.086-11.841h-.388l7.474 11.841zm-49.017-18.927-.291-.097.29.194v-.097zm-.583-.68-.097.098.097.097v-.194zm-.679-.97v-.097l-.097.097h.097zm.388-.388.291.194v-.194h-.29zm.583-.389-.389.097h.097l.292-.097zm-.68-.097-.291-.29.097.096.194.194zm-.68-1.067h-.193l.29.097-.096-.097zm.68-1.165h-.388l-.097.097.485-.097zm.388.194-.485-.485.194.097.291.388zm-3.688-4.174-.194-.097v.097h.194zm-4.174 0-.29-.388.096.485.194-.097zm-35.33-3.203 2.911-2.232-3.203 2.135.291.097zm5.823-4.659.291-.291-1.164.485.873-.194zm-36.884-6.503-10.58 3.397 5.824-1.65 4.756-1.747zm26.304-16.5-2.815.484-41.93 6.795 4.367 9.997.291.097-1.068 3.98 3.107-1.359 3.397-3.009 5.824-.194 6.697-2.426 4.562.679-1.068 1.65 8.348 2.815 7.182 3.494 1.65 3.883 5.339-1.165 12.618-10.289 4.659.194 19.024 14.366 3.883-.777 4.077 5.436.776 8.638-1.262 5.436.583 2.718 3.397 6.794-1.553-5.338 4.368-.098.388 3.883-2.33 6.018 8.057 11.065 3.009.097-2.524-3.397 3.106.388 1.844-1.164-.776 6.212 4.173 3.3 2.815 7.57 3.786 2.33 4.853 1.262 6.697 8.542 3.494 1.844-4.659.29 2.136 2.427 7.668-2.523 3.785-2.136 3.495-12.23-1.748-19.024-.388-1.941-9.318-15.53-7.96-11.26-4.464-9.22 3.785 3.203.777-.583 1.65 8.056 4.27 6.115-4.173-8.153.194-3.882-12.52-15.24-3.01-4.755-3.98-8.057-2.717-6.794-2.136-2.427-.485-3.106-.097-.097-6.697-.388-2.621 2.038-1.456 7.474-1.359-3.494-45.814 5.727-3.3-5.145.097-.097z"
        data-id="FL"
        data-name="Florida"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="GA"
        d="m845.854 396.097-.097-2.912-.68 2.524.777.388zm1.068-4.465-.389-2.232-.29 1.358.679.874zm-45.426-61.15-1.262.291-3.688.777-13.589 2.815-1.262.29-1.359.195-7.57 1.456-2.039.388-8.25 1.553-1.747.194.097.195 13.006 39.601 7.183 12.813-1.747 1.94-1.068 7.572 2.135 3.882.195 7.086 2.62 4.95v.097l-.097.097 3.3 5.145 45.814-5.727 1.359 3.494 1.456-7.474 2.62-2.038 6.698.388-.582-10.483 1.261-2.232-.68-4.174 1.36-3.98 2.038-2.232-1.456-1.359 3.397-4.173h-.097l-5.823-5.436-7.96-11.356-4.367-2.039-18.734-15.724-4.562-5.824-8.832-3.688-.486-1.941 2.718-5.339z"
        data-id="GA"
        data-name="Georgia"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="MS"
        d="m716.76 442.784-.485.097v.097l.485-.194zm9.027-1.164h-1.359l1.262.097.097-.097zm-11.26.97-.388.388.097.097.292-.485zm9.124-.776h-3.688l3.494.097.194-.097zm-40.475-92.502v.098l-4.076 6.794.388 5.241-5.533 6.115 1.456 1.748-3.688 15.53 1.747 3.3-.97.68.096 2.135v.679l2.233 5.241-.194 3.204 3.591 4.367-7.377 12.619-1.165 7.57-2.038 3.01 1.359 3.494-1.262 1.262 33.487-3.689-1.165 4.66 4.271 8.347 2.232 2.814v-.097l3.592-4.076 7.57-1.65 6.99.776 1.067-1.359v-.097l-4.95-29.895-.194-21.84-.583-39.795-1.359-.874-.388-.776h-.194l-4.853.679-8.542 1.165-19.412 2.426-2.136.194z"
        data-id="MS"
        data-name="Mississippi"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="SC"
        d="m801.496 330.482-2.718 5.339.486 1.941 8.832 3.688 4.562 5.824 18.734 15.724 4.367 2.039 7.96 11.356 5.823 5.436.971-4.465-1.553-4.271 4.174 3.106 2.33-1.844-3.98-3.3 4.853-.292 7.57-6.406-.873-1.65 4.66-3.591-.486-1.747 3.397-2.136.194-4.95 5.339-9.9 3.591-4.562.388-.194-21.645-13.686-8.056 1.553-10.968-.389-5.436-2.814-32.225 10.191h-.29z"
        data-id="SC"
        data-name="South Carolina"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="IL"
        d="m661.434 198.185-.194.486 3.688 2.329 1.165 2.33 3.883 3.688-.098 3.106-2.135 6.115-4.853 3.494-4.368.874-.873 5.047 1.455.68-1.455 9.9-3.592 2.232.68 3.786-.874.388-.776 4.27 3.106 8.64 11.065 9.318.97 4.464 2.136 2.233 6.988-.388-1.261 6.503-.486 6.988 4.174 3.398 6.6 2.912 3.494 2.717 1.942 5.533-1.068 2.038 6.892 5.63.29.097-.582-.582 1.942-4.562 7.473 2.038 1.845-2.135-1.456-4.271 6.115-3.592-1.65-2.329 1.456-3.3v-.291l-.389-.097.097-8.64 2.136-1.552 3.688-8.639-.776-3.785-2.427-4.562 1.359-5.144-6.794-47.853-.971-1.067-2.524-5.727-2.038-2.135-.874-5.63v-.194l-13.103 1.844-7.862.97-21.16 2.427z"
        data-id="IL"
        data-name="Illinois"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="IN"
        d="m750.344 200.224-14.85 2.62-3.398.68-12.036 1.94-2.523 2.04-3.786 1.746-1.456-.097-1.747-.873-.582-.583 6.794 47.852-1.359 5.145 2.427 4.562.776 3.785-3.688 8.639-2.136 1.553-.097 8.638.389.098.388-.098 1.456-2.717h3.591l4.368-1.456 5.435 2.038.583-2.232 3.106-2.33 4.659.68 2.524-4.95 6.891.582-.097-2.815 6.115-8.056-.97-3.689 4.27-.097 5.241-4.174-1.261-4.756.194-.194-.194-1.65-5.824-34.36-2.62-14.657-.292-1.553-.291-1.262z"
        data-id="IN"
        data-name="Indiana"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="KY"
        d="m693.174 317.185-.292-.777-.582-.194-.388 1.262.097.097 1.068-.097.097-.291zm66.39-63.48-.193.194 1.262 4.757-5.242 4.173-4.27.097.97 3.689-6.115 8.056.097 2.815-6.891-.583-2.524 4.95-4.66-.679-3.105 2.33-.582 2.232-5.436-2.038-4.368 1.456h-3.591l-1.456 2.718-.388.097v.29l-1.456 3.301 1.65 2.33-6.115 3.59 1.456 4.272-1.844 2.135-7.474-2.038-1.942 4.562.583.582.194.388-.874 7.96-.388.194-2.524 1.553-.097.29 2.815-.387 19.607-2.621-.97-3.883 3.3-.097 39.504-5.241 27.76-4.66.388-.29.68-.777 7.28-3.882 5.63-7.377.776-2.524 3.688-2.912 4.66-5.92.679-.971-.292-.097h-2.426l-3.106-1.748-5.533-6.697-1.941-6.794v-.194l-.194-.195-4.077-2.329-1.844-3.106-3.688 3.591-2.33.583-2.912-1.165-2.523 1.941-5.242-2.33-1.359.583-4.95-4.27-2.524-1.263-4.756.583-.776.776z"
        data-id="KY"
        data-name="Kentucky"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="NC"
        d="m890.212 332.23-1.068 1.067.194.194.874-1.262zm.776-5.63-.485.776.194.777.291-1.553zm5.824-9.027-1.456.97-.776 1.165 2.232-2.135zm12.521-6.115-.582-.388-1.262-.097 1.844.485zm-2.62-.583h-.874l-1.456.777 2.33-.777zm3.008 1.068 2.815-6.988-1.94 2.912-.875 4.076zm4.174-9.22 1.262-1.845h-.68l-.582 1.844zm8.154-7.572-2.136-10.774 1.844 5.63.292 5.144zm-11.842-24.557-.194.097-.292.097h.098l5.338 9.027 4.174 4.174-9.124-13.395zm-1.747.583-.777.194.194.097h1.65l-.194-.582-.29.097h-.292v.194l-.194.097-.097-.097zm-89.784 22.13-.485 1.456.097 4.174-1.068-.097-2.523 5.144-2.815.291-5.242 5.144-2.329-.873-3.009 4.465-7.96 7.183-3.882.97-4.076 3.786-.194 2.523-3.592 1.941.097 4.271v.97l1.262-.29 13.589-2.815 3.688-.777 1.262-.29h.291l32.225-10.192 5.436 2.814 10.968.389 8.056-1.553 21.645 13.686.389-.292 9.997-4.076.097-5.339 3.591-6.503 3.883-3.688 8.056-5.339 1.068-1.941 2.135.97.971-6.406-1.165 2.233-4.076 1.359-3.883.097 4.756-3.494-1.456-1.554 1.65-3.494-9.124-1.456-.388-.485 7.765-1.456 2.524 1.262 3.203-.291 2.62-1.942 1.942-3.785 1.747-.485-.291-5.339-2.233-2.135-2.232 2.038.485 5.144-1.65-6.309-1.262-.29-9.609 3.979 4.27-4.174.195-1.65 4.465-1.068 1.262-3.3 3.009 1.747-3.203-4.756-2.233-1.941-38.825 11.065-24.751 6.31-25.043 4.658-.097-.194z"
        data-id="NC"
        data-name="North Carolina"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="OH"
        d="m818.191 206.63-2.427-10.483-.485-2.136-2.718-11.938-3.494 2.232-7.474 5.727-4.853 5.92-3.785.583-6.989 3.98-3.883-2.33-11.744-1.359-6.212 1.553-6.115 1.456-6.406 1.36-.971.29.291 1.553 2.62 14.657 5.825 34.36.194 1.65.776-.776 4.756-.583 2.524 1.262 4.95 4.271 1.36-.582 5.24 2.33 2.524-1.942 2.912 1.165 2.33-.583 3.688-3.591 1.844 3.106 4.077 2.33.194.194 4.174-2.039 1.456-3.203-1.165-3.3 3.3-5.047 2.427-.388-.292-4.271 3.98-5.436.68.777 3.59-2.718 3.107-4.66.485-21.256.194-.097-.485-2.038z"
        data-id="OH"
        data-name="Ohio"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="TN"
        d="m786.257 300.49-27.76 4.659-39.505 5.241-3.3.097.97 3.883-19.606 2.62-2.815.389v.097l-.776.97-.388-.097v-.873l-1.068.097.097.097.582 2.718-1.94 2.426-.195 4.465v.874l-2.912 5.63.582 3.98-2.717 4.27.97 3.882-3.494 3.203.194.195 2.136-.195 19.412-2.426 8.542-1.165 4.853-.68h.194l-.097-.193 16.307-2.233 7.765-.97 15.53-2.524 2.912-.485 1.747-.195 8.25-1.553 2.038-.388 7.571-1.456 1.36-.194v-.97l-.098-4.271 3.591-1.942.195-2.523 4.076-3.786 3.883-.97 7.959-7.183 3.009-4.465 2.33.874 5.24-5.145 2.816-.29 2.523-5.145 1.068.097-.097-4.174.485-1.456-1.553.291-5.532 1.553-6.6 1.36-16.598 3.397-1.748.29-.388.292z"
        data-id="TN"
        data-name="Tennessee"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="VA"
        d="M908.75 270.983h.292l.291-.098-.194-.485-.388.583zm-3.3-10.872v.486l.486-.291-.485-.195zm1.748-3.397-.097-.776.097.776zm-.583 1.165-.194 1.262-.29.485.484-1.747zm.874-2.524.097-.582-.194.582h.097zm.582-2.62.292-.68-.486 1.747.194-1.067zm.098-1.456.388-2.136-.486.486.098 1.65zm1.747-9.61.194-.873-.097.194-.097.68zm-.389-2.232-1.261.485-1.942.874-.68.873.292.098-2.33 14.462.874 2.33 1.359-6.018 2.524-7.863 1.164-5.144v-.097zm1.942-.776-.292.097-.097.388-.485 3.009.388-1.068.486-2.426zm-101.431 37.175-.68.97-4.659 5.921-3.688 2.912-.777 2.524-5.63 7.377-7.28 3.882-.679.777 1.748-.292 16.597-3.397 6.6-1.359 5.533-1.553 1.553-.29.097.193 25.043-4.659 24.75-6.309 38.826-11.065-.291-.485-.097-.292.68.68.776-.194-.097-.097-.68-3.3.485.097 1.553 2.911.292-.097.194-.097-.388-.776-3.98-6.115-4.95.873-2.233 1.845-2.135-1.942-7.28-2.426-5.047-.194 9.803-.874 5.436 3.688 1.553-2.426-4.368-5.533 3.106.194-1.65-4.465-3.883.195-9.22-7.474h-1.165l13.006 6.406-.873-4.465.873-1.456-6.6-2.524-5.727-.388-2.815-2.524-2.33 1.456-.873-6.697.97.194-.193-5.435-.194-.194-.195.097-.194-.097-.485-.389-.291-.29-3.106-1.36-3.203-2.33-4.465-1.164-.291-.097v.097l-.583 4.077-9.027-3.883.194 5.63-4.95 9.415-3.009 3.3-1.941 5.727-5.92-2.039-2.913 13.201-2.33 4.465-.387 5.824-1.748 2.814-6.503 1.942-5.338 4.173-2.524.389-2.427 2.135-6.115-2.232-1.067-3.01-.194-.096z"
        data-id="VA"
        data-name="Virginia"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="WI"
        d="m705.792 134.803-2.427 3.009-1.456 4.368.68 2.426 3.203-9.803zm-55.714-22.81 1.456-2.038-1.068.97-.388 1.068zm2.232-3.203-.485-.582-1.068.68 1.553-.098zm-21.16 5.436-2.232 2.523 1.068 11.648-6.212 5.63-1.165 5.435 3.397 3.106-.97 13.395 3.59 2.718 2.33.194 7.377 4.465 4.659 4.853 5.92 3.009 1.36 7.474v.485l2.815 3.397-.777 2.62.97 5.727 2.913 3.98 5.338 2.815-.097.485 21.16-2.426 7.862-.971 13.103-1.844-.388-1.456v-4.562l-2.62-4.853-.68-6.115 1.262-6.795-.68-5.241 2.33-6.503-.874-1.068.194-6.018 1.262-4.562-1.456-1.553-2.815.97-1.553 4.077-3.688 2.136 1.165-5.145 3.3-4.367.194-1.942.097-.097-4.659-4.659v-6.6l-5.241-4.27-7.183-.486-7.377-1.941-15.918-4.854-3.106-1.747-.291.291-4.95-.679-1.65.97.679-7.085-7.96 4.077-9.706 1.553-.097-.194zm19.025-5.145-.194-.68-.68.292.874.388zm-3.495-.68.292-.582-.195-.194-.097.777zm7.086-1.65-.291-1.358-.291 1.65.582-.291z"
        data-id="WI"
        data-name="Wisconsin"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="WV"
        d="m836.73 223.713-13.783 3.397-4.27-18.442-.195.097-.485 21.257-3.106 4.659-3.592 2.718-.679-.777-3.98 5.436.292 4.27-2.427.389-3.3 5.047 1.165 3.3-1.456 3.203-4.174 2.039v.194l1.941 6.794 5.533 6.698 3.106 1.747h2.426l.292.097.194.097 1.067 3.009 6.115 2.232 2.427-2.135 2.524-.388 5.338-4.174 6.503-1.941 1.748-2.815.388-5.824 2.33-4.465 2.911-13.2 5.921 2.038 1.941-5.727 3.01-3.3 4.95-9.415-.195-5.63 9.027 3.883.583-4.077v-.097l-2.815-4.853-5.824-.68-3.397 2.621v1.941l-2.912.68-4.27 3.009-2.233.485-4.465 6.31-2.233-10.192-1.941.485z"
        data-id="WV"
        data-name="West Virginia"
        style={{
          strokeWidth: 0.97063118,
          fill: '#f9f9f9',
        }}
      />
      <path
        id="DE"
        d="m893.803 207.697.388 1.456 8.057 23.004 9.22-2.717-.096-.195h.194l.29.098.195-.098-.194-.388-2.33-6.212-11.356-10.774.485-7.474h-2.33l-1.746 1.36-.777 1.94z"
        data-id="DE"
        data-name="Delaware"
        style={{
          strokeWidth: 0.97063118,
          fill: '#f9f9f9',
        }}
      />
      <path
        id="DC"
        d="m878.176 229.148.485.389.194.097.195-.097.194.097.68.388.193.291v.68l.194.388 1.262-2.33-1.359-.776-1.65.097-.388.776z"
        data-id="DC"
        data-name="District of Columbia"
        style={{
          strokeWidth: 0.97063118,
          fill: '#f9f9f9',
        }}
      />
      <path
        id="MD"
        d="m911.566 238.272.68-5.241-.583 3.882-.388 1.65-.098.195.292-.098.097-.388zm.485-9.027-.194.097.194.583v1.165-1.845zm-73.38-6.018 2.233 10.192 4.465-6.309 2.232-.485 4.27-3.01 2.913-.679v-1.941l3.397-2.62 5.824.679 2.815 4.853.29.097 4.466 1.165 3.203 2.33 3.106 1.358.291.291.388-.776 1.65-.097 1.36.776-1.263 2.33v.097l-1.844 5.63 6.018 3.882 6.018.291 3.98 1.844-1.65-4.659-5.145-1.747-1.262-3.98 3.203 4.271 2.621.389-2.33-2.33-1.844-6.891.486-3.98-2.039-4.368 2.136-1.747 1.553-5.63-.583 8.348 1.65 2.815 1.554-3.3.873 5.435-1.65 3.98 4.756 1.747-4.077 1.359 2.136 3.98 3.494 1.164 1.941-3.397-.194 4.756 3.3-.097 2.136 2.426h.097l.68-.873 1.94-.874 1.262-.485-.097-.194 2.524-7.474v-.291l-.485-1.941v-.098l-9.221 2.718-8.057-23.004-.388-1.456-1.65.486-6.891 2.135-37.952 10.58-6.892 1.844-1.747.485z"
        data-id="MD"
        data-name="Maryland"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="NJ"
        d="m916.807 207.31-.485-1.166v1.165h.485zm.97-3.592.292-2.912-.582 2.524.29.388zm-3.979-29.799-10.191-2.523-1.748-.486-1.65-.388-4.076 9.027 1.747 2.135-.097 6.504 1.844.29 3.785 9.901-.194.292-4.756 6.988.485 5.339 11.454 3.882.097 4.465 2.62-3.688.389-5.339 2.718-1.844-1.068-3.98 2.038-4.756v-10.386l-.68-3.397-4.561.097 1.165-4.659.68-7.474z"
        data-id="NJ"
        data-name="New Jersey"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="NY"
        d="m913.507 181.782-1.456 2.038-.388.582 1.844-2.62zm13.395-4.757 4.853-4.27v-.194l-4.853 4.464zm-12.716 3.01v-3.3l-.29 1.746.29 1.553zm22.519-15.53-1.165-.292-.194.874 1.359-.583zm2.62-1.748-.096.97.194-.582-.097-.388zm-2.717.097-6.503 6.018-9.998 4.271-2.62 2.232-.195 2.136-2.717 2.232.388 2.912 4.174-1.65 6.115-4.95 6.794-3.591 10.289-9.707-7.28 5.533-2.33.97 3.883-6.406zm3.009-4.076.388-.583-1.165 1.36.777-.777zm-109.099-3.592-1.553-.194 1.165 1.553.388-1.359zm32.225-29.701.194-1.068-.776.97.582.098zm.485-6.989-.388.195-.485 1.067.873-1.262zm-41.057 55.132.679 2.912 5.144 1.262 29.508-8.056 29.7-8.93 5.436 4.174 1.068 2.426 6.31 2.718.193.388 1.65.389 1.748.485 10.191 2.523-.194-.485.874 3.98 1.94-.486 1.069-4.367v-.098l-1.748-1.65 2.524-3.106-1.165-1.456-3.688-14.268-.194-.97-.486-.292-.29-4.27-.292-4.66-.291-5.047v-.29l-.194.096-4.853-15.918-5.145-8.056-1.456-9.61-4.368-10.191-.582.29-20.286 6.795-4.077 4.368-4.562 8.736.194 1.941-6.018 9.124 3.689 1.262 1.068 6.891-4.271 5.63-12.813 7.765-2.426-.97-9.512 1.358-8.833 5.339.485 2.815 3.106 2.717-1.747 8.542-6.988 8.153-.097.097z"
        data-id="NY"
        data-name="New York"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="PA"
        d="m900.015 170.134-6.309-2.718-1.068-2.426-5.435-4.174-29.701 8.93-29.508 8.056-5.144-1.262-.68-2.912-1.65 1.262-2.62 1.844-4.756 4.853-.583.486 2.718 11.938.485 2.136 2.427 10.483.485 2.038 4.271 18.442 13.783-3.397 1.941-.486 1.747-.485 6.892-1.844 37.952-10.58 6.891-2.135 1.65-.486.777-1.94 1.747-1.36h2.33l.29-.873 3.786-4.271.388-.68.291-.194-3.785-9.9-1.844-.291.097-6.504-1.747-2.135 4.076-9.027-.194-.388z"
        data-id="PA"
        data-name="Pennsylvania"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="ME"
        d="M946.8 118.4h-.097l.194.096-.097-.097zm7.182-20.675-.776-1.165v.582l.776.583zm-1.359-1.068v-.97l-.097-.583.097 1.553zm3.495-4.076-.194-.098.097.292.097-.194zm9.706-4.854-.194-1.456-.388.68.582.776zm-2.427.583.097-1.068-1.164.194 1.067.874zm3.592-3.203h-.389v.194l.389-.194zm-4.853 1.456-.874-.195-.097.874.97-.68zm4.95-3.01.873.68-.29-.776-.583.097zm-2.62.098-.874 1.65 1.164-.583-.29-1.067zm-4.175.097-.388.582.291.874.097-1.456zm5.727-3.203-.097-.777-.291.486.388.29zm-.485.388-.874-.777v.68l.874.097zm-5.436 2.232-.194-1.067-.388.873.582.194zm9.221-3.397-1.456 2.136-.097-1.553 1.553-.583zm7.086-6.503-.68-.97-.388.193 1.068.777zm2.62-4.368-.582-.291-.097.291h.68zm1.262-7.57h-.873l.97.29-.097-.29zm1.456.97-.29-1.747-.777-.097 1.067 1.844zm-1.553-1.553-.194-1.844-.68 1.261.874.583zm-56.296 15.239 14.074 33.001.194.68 6.115 7.473v-.097l.97-.29.195-5.533 1.553-1.942.97-5.144-.873-.874 1.65-5.047 5.63-2.62 3.688-4.465 1.359-7.766 5.92-.388-.776-3.98 7.377-2.814.485-4.368 1.747.388 4.854-3.98 2.135-5.144-4.95-4.95-5.242-1.068-1.94-3.98v-2.329l-3.204.97-3.591-1.26v-3.98l-9.707-20.966-7.085-3.689-7.862 6.6-2.136-.387-1.844-3.398-2.524.97-3.591 17.86 1.262 5.824 1.068 11.842-2.815 9.124 1.941 1.456-2.33 4.465-2.523-.388-.194.194z"
        data-id="ME"
        data-name="Maine"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="MI"
        d="m719.963 138.2-.485-.776-.097.97.582-.194zm1.553-1.747-1.165-1.553-.194.68 1.36.873zm.97-6.988-.97-.874v.194l.97.68zm-2.426 76 12.036-1.941 3.397-.68 14.85-2.62.292 1.261.97-.29 6.407-1.36 6.115-1.456 6.212-1.553-.097-.29 3.203-6.31-.291-5.241 3.591-9.027 2.815 1.65 1.068-2.039-.292-7.765-2.62-4.853-3.883-10.288-3.397-3.786-1.747-.485-6.31 4.368.68.873-3.3 6.212-3.203-.582-.97-6.503 1.358-.486 2.815-6.503.291-11.453-4.368-9.707-9.706-1.65-.97-1.456-9.028-2.62-4.076 5.047.388 4.368-3.106 3.882.68 6.018-3.01 2.136v-7.571l-2.717 5.726-3.203 5.048-2.136 1.65 1.068 5.338-1.359 5.533.777 6.891-.971 3.398 6.989 13.394.873 5.145-.873 9.512-4.66 10.677-.582.388zm20.772-87.454-2.524.194 1.553 1.165.97-1.359zm-14.754 2.524h-.776l.873.388-.097-.388zm16.986-12.327-.97-1.553-.389.097 1.36 1.456zm-87.94 7.085 3.107 1.747 15.918 4.854 7.377 1.94 7.183.486 5.241 4.271v6.6l4.66 4.66v-.098l3.785-10.968 4.562-3.203 3.494-3.883.582 3.495 3.592-5.533 8.638-3.3.68-1.359 8.735 1.068 3.398 1.747 1.65-4.27 1.553.97 6.794-1.068-1.65-2.718-3.009-1.747.582-6.309-5.92 3.3-5.436-.68-1.747-4.173.582-1.359-7.377 3.494-4.756.292-8.541 5.241-.97 1.941-5.242-1.262-3.3 1.456-6.6-5.726-14.657-4.465-.291-1.747-9.415 9.027-5.339 1.358-7.57 5.727-.292.194zm34.361-22.033-11.356 5.63 3.785 3.688 1.456-3.688 3.883-4.756 2.232-.874zM676.77 79.962l-7.765 5.339-.388 2.62 6.115-4.464 2.038-3.495z"
        data-id="MI"
        data-name="Michigan"
        style={{
          cursor: 'pointer',
          strokeWidth: 0.97063118,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      {/* <path
        id="AK"
        d="m101.283 542.953-.486.195.389.097.097-.292zm3.591.583v.097-.097zm-1.747-1.65v.29l.194-.096-.194-.194zm-.874-.486v-.097.097zm1.845.971v-.194l-.098.097.098.097zm-.195-.194v-.097h-.194l.194.097zm-75.709-63.77-.097.679.194 1.941-.097-2.62zm-.485-2.621.097.873.097-.29-.194-.583zm76.194 65.226.098-.582-.389.194.291.388zm11.066 4.756-.097-.097.194.388-.097-.29zm-7.183-3.397-1.068-.97v2.329l1.068-1.359zm2.427 2.135-.098-.679-1.65-.097 1.748.776zm5.823 1.36-.097.193h.194l-.097-.194zm.389.096h-.195l.389.097-.194-.097zm1.164.389h-.194.194zm-85.706-65.81.388.098.291-.097h-.68zm83.571 64.45-.777-.096.292.29.485-.193zm-88.813-72.02-1.359-.582-.097.29 1.456.292zm91.24 72.215-.195-.097v.097h.195zm5.92 1.165-3.785.29-.874.39 4.66-.68zM19.75 457.732h-1.068l.194.291.874-.291zm115.796 93.084v-.389h-.194l.194.389zm5.047.097.194-.194-.194-.195v.389zm3.786 1.067.194-.097h-.097l-.097.097zm-3.106-1.747-.097-.388h-.194l.29.388zm6.503 1.456-.097.097h.097v-.097zM20.332 452.782l-1.456.194 1.844 1.65-.388-1.844zm122.3 97.451.194-.582h-.097l-.097.582zm16.403-1.456.097-.194-.194-.097.097.291zm-2.426-.873-3.397 3.009 2.426-.194 2.815-2.233-1.844-.582zm6.115 1.067-.68-.194.486.389.194-.195zm1.359.097-1.068-.29-.194.096 1.262.195zm-3.689-1.358h-1.067l1.844.485-.777-.485zm4.465.97-.097-.194-.388.097.485.097zm-2.912-1.165-.388-.194v1.068l.388-.874zm12.424 2.427-.097-.097h-.194l.291.097zm.194-.097v-.097l-.194-.097.194.194zm-1.65-.582.194.388v-.097l-.194-.291zm.874 0-.874-.292 1.068.777-.194-.485zm1.262-.971v.097-.097zm11.55 1.456-.194-.388h-.097l.291.388zm104.44-6.503-.194-.194.097.194h.097zm-117.64 3.009v-.097l-.097.097h.097zm120.455-4.756.291.388h.194l-.485-.388zm-106.09 7.28-.097.096v.292l.097-.389zm-12.036-1.748.194-.776h-.097l-.097.776zm123.756-7.765-.874.485.777.389.097-.874zm-122.009 7.28-.097-.194.097.194zm-7.28-2.136-2.426.486-2.135 2.815 4.562-3.3zm17.375 3.689-.582.485.582-.097v-.388zm111.914-9.318-.194-.388-.098.194.292.194zm-121.232 6.794-.68-.097.68.68v-.583zm114.825-5.532-.194.194.194.68v-.874zm-113.272 5.435-.291.097.388.291-.097-.388zm7.183 2.038h-.292l-.194-.194.486.194zm-7.96-2.038-.485-.291.194.291h.291zm6.504 1.068-.874.291-.582 1.553 1.456-1.844zm105.41-6.795v.68l.388-.485-.388-.195zM174.08 543.44l.777-.194h-.097l-.68.194zm-.97-.583-.195-.194v.097l.194.097zm117.834-3.785-.194-.097-.097.291.291-.194zm-106.478 5.824-.194-.097-.194.29.388-.193zm105.507-5.63.098-.485-.195-.097.098.582zm-.776-.485-.291.388.485.097-.194-.485zm-100.654 4.756-.195-.194h-.097l.291.194zm100.363-6.503.776.29.291-.387-1.067.097zm1.165-.68-.292.194.486.292-.194-.486zm-2.233.583-.194-.389-.194.194.388.195zm9.706-3.592-1.261 3.592 1.261-.777v-2.815zm-115.02 7.474h-.097.098zm106.479-6.115-.874.874.194.97.68-1.844zm-90.366 7.765v-.388l-.097.194.097.194zm89.298-8.736 2.815 4.271 6.31 3.98-1.457-3.397-6.018-5.145-1.65.291zm-93.18 7.183-.098-.291-.194.097.292.194zm96.48-8.833-.388 1.456.68-.485-.292-.97zm2.039 0-.097.971.873.291-.776-1.262zm-95.413 7.571-.486-.097-.485.194.97-.097zm9.997.777-.388.68.194-.583.194-.097zm1.456.097-.874.097.486.582.388-.679zm-58.82-12.424.97.485-.194-.194-.776-.291zm38.534 9.61.097-.098-.097.097zm.291-.098h.097v-.097l-.097.097zm100.363-7.474.486 1.844.97-.582-1.456-1.262zm-97.742 6.406.097-.097-.097.097zm93.569-5.63.485 4.466.97-.971-1.455-3.494zm.485-1.455 2.232 3.106-.29-2.039-1.942-1.067zm-6.892.776-.582 1.844.777-1.261-.195-.583zm-77.65 4.756-.097-.097.097.097zm9.22.194-.193-.29.194.387v-.097zm68.625-6.406 3.882 6.406-.582-4.367-3.3-2.039zm-63.189 3.397-.29.292.485.194-.195-.486zm-1.261.195.097-.292h-.389l.292.292zm-.971 0-2.524 1.65-3.106 4.076 1.553 1.65 7.183-5.338-3.106-2.038zm61.247-6.31-.68-.388v.583l.68-.194zm-61.83 5.145.098.388.68.388-.777-.776zm63.674-6.989-1.941.97 1.844.583.097-1.553zm-1.262 0-.194-.194-.097.194h.291zm5.921-1.553-.776-.29-.195.581.971-.29zm-4.174.68-.68-.097v.194l.68-.097zm2.136-.777 3.98 5.824-1.068-5.338-2.912-.486zm-64.062 6.31-2.33 1.746 1.068 1.165 3.106-2.33-1.844-.582zm-26.401-3.69-.097-.096v.097h.097zm-1.068-.484-.097-.486v.194l.097.292zm29.799 1.261-.195.098v.097l.195-.194zm-.971-.194h-.097l-.194.292.29-.292zm2.33-.776-.292-.194v.097l.291.097zm.776-.097-.291-.194v.097l.291.097zm-1.262-.291h-.388v.097l.388-.097zm19.316-1.942.097-.29-.194.193.097.097zm5.92-3.106 1.165-1.456-.388.291-.776 1.165zm-11.841-.194.388-.291.097-.388-.485.68zm0-1.068-.388.292.679-.195-.291-.097zm-15.919 0-.097-.388h-.097l.194.388zm15.53-.097-.388.389-.194.388.583-.777zm10.678-1.164h.194-.194zm.485 0-.194-.098v.098h.194zm-1.165-.098.097.098v-.098h-.097zm-7.96.583.39-.388-.486.388h.097zm5.922-1.165zm-4.756.291-2.33 3.786 3.01-3.495-.68-.29zm-3.01.486-.29-.389-.098.194.389.195zm7.378-.874-.195-.097.097.097h.098zm2.523.194v-.68l-.194.292.194.388zm-71.244-7.474-4.66-.194 3.204 3.397 1.456-3.203zm66.294 6.892.194.68.485-.777-.68.097zm-3.883-.097-.29 2.135.485-1.359-.195-.776zm-84.25-16.113.097-.388-.097.388zm83.28 14.754.097.291.194-.097-.291-.194zm-.486.388-.194-.582-.29.194.484.388zm4.562-1.165v-.388l-.29.194.29.194zm-4.367-.582v.97l.29-.679-.29-.291zm-7.377-1.165v-.291.291zm-50.667-12.036.194-.582-.097.097-.097.485zm.291-.97-.097-.097-.097.097h.194zm4.27-2.33v-.097.097zm0-.388-.096-.194.097.194zm1.748-2.524h-.097.097zm.582.194-.388-.194v.097l.388.097zm-.582-.388v-.194l-.194.194H180zm-15.53-4.562-.194-.485-.097-.291.29.776zm1.456-1.747h.097l.097.097-.194-.097zm-2.62-.485-.777-.97.582.776.194.194zm-1.554-1.553h-.194l.291.097-.097-.097zm.194-1.068zm-.194-.097.194.097-.194-.097zm25.722 7.668-1.068.097.583.291.485-.388zm-26.79-9.415-.776 2.912 2.426.388 3.204 3.3 1.94-.873-6.794-5.727zm16.986 1.165v-.195.195zm-4.853-10.29-.194-.096.097.097h.097zm2.815.971.291-.097h-.097l-.194.097zm1.941-.582h.292l.873-.388-1.165.388zm3.495-1.068.194-.194-.291.194h.097zm.485-.097.582-.29-.485.096-.097.194zm1.456-.582-.485.097v.097l.485-.194zm.582-.097zm61.732-17.472-.388-.29-.68-.292 1.068.582zm-50.86-2.135.873-1.165-.485.389-.389.776zm1.164-1.359.388-.582-.194.194-.194.388zm.582-.776.68-.583-.388.194-.292.389zm30.575.194.486.485h.29l-.776-.485zm-15.627-6.406-3.98 3.3-2.426-.68-5.63 3.203-1.067-.679-6.406 7.183-6.504 1.456.583 3.494 2.912 3.98 5.435 5.24-.873 2.04 4.076 1.746-2.135.389-2.62-2.039 1.358 3.01-1.747 1.067-5.533-5.047-4.368.776-7.473 2.815 3.397 3.785-.486 2.33 2.233 2.718 7.377 2.912 5.338-2.718.874 2.038-1.456 6.115h-4.465l-5.242 2.33-.29-1.65-2.718 1.067-1.262 2.815-4.465 3.397v4.95l1.747.777-1.359 4.174 5.824 5.047 3.688-1.553-.776 6.212 1.067 1.359 4.465.97 1.65 1.845 3.883.291 1.844 1.941 3.98-1.165-1.844 2.524-1.456 5.144-11.842 7.668-1.553 1.553-2.233-.873-3.59.873-5.145 3.398 8.056-2.33 1.165 1.747 10.385-3.397.292 1.359 4.076-4.077 8.542-5.92.68.388 7.473-5.921-1.941-2.33 2.524-4.173 6.6-7.862 5.047-.971 1.553 1.068-6.115 1.747-1.65 6.503.194 3.494 2.136-.194 10.288-6.212.777-2.33-.874-3.59 3.106.776 2.233-1.456 6.406 3.882-.485 1.068 14.559 1.844 3.397-1.067.97 1.455 12.62 6.018 2.134-1.261.195-7.28 1.65 3.3 8.153 5.92.68 2.427 7.085 3.98 1.844 5.144 1.747-3.98 3.592 6.99 2.426-3.98-1.941-4.95-7.474-.777-11.453-10.968-6.212-4.562-4.756 4.659h-2.815l-6.504-4.27-6.406-.292-9.124-57.558-1.553-2.718-3.688-2.233-5.533 1.068-4.27-.874-5.436-2.135-5.727.388-1.456-2.717-4.562-.68-.776-1.65-2.038 2.33-.583-4.368z"
        data-id="AK"
        data-name="Alaska"
        style={{
          strokeWidth: 0.97063118,
          fill: '#f9f9f9',
        }}
      /> */}
      <rect
        id="MDB"
        width={82}
        height={39}
        x={945}
        y={349}
        fill="#f9f9f9"
        rx={15}
        strokeWidth={0}
        style={{
          cursor: 'pointer',
          strokeWidth: 0,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        style={{
          cursor: 'pointer',
        }}
        id="MDL"
        fill="#fff"
        strokeWidth={0}
        d="M986.62 357.94V379h-5.13v-13.17L976.93 379h-4.44l-4.59-13.2V379h-5.13v-21.06h6.27l5.73 14.67 5.61-14.67h6.24Zm22.62 10.41c0 2.08-.45 3.93-1.35 5.55-.88 1.6-2.16 2.85-3.84 3.75-1.66.9-3.62 1.35-5.877 1.35h-8.01v-21.21h8.01c2.277 0 4.247.44 5.907 1.32 1.66.88 2.93 2.12 3.81 3.72.9 1.6 1.35 3.44 1.35 5.52Zm-11.517 6.06c2 0 3.547-.53 4.647-1.59 1.12-1.06 1.68-2.55 1.68-4.47s-.56-3.41-1.68-4.47c-1.1-1.06-2.647-1.59-4.647-1.59h-2.43v12.12h2.43Z"
        onMouseEnter={() => {
          const targetRect = document.getElementById('MDB');
          if (targetRect instanceof SVGRectElement) {
            targetRect.style.fill = '#C9DAF8';
          }
        }}
        onMouseLeave={() => {
          const targetRect = document.getElementById('MDB');
          if (targetRect instanceof SVGRectElement) {
            targetRect.style.fill = '#15c';
          }
        }}
      />
      <rect
        id="NJB"
        strokeWidth={0}
        width={82}
        height={39}
        x={945}
        y={294}
        fill="#15c"
        rx={15}
        style={{
          cursor: 'pointer',
          strokeWidth: 0,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        id="NJL"
        style={{
          cursor: 'pointer',
        }}
        strokeWidth={0}
        fill="#fff"
        d="M986.61 324h-5.13l-8.58-13.02V324h-5.13v-21.21h5.13l8.58 13.14v-13.14h5.13V324Zm16.62-21.21v14.49c0 2.22-.61 3.93-1.83 5.13-1.2 1.2-2.867 1.8-5.007 1.8-2.32 0-4.16-.65-5.52-1.95-1.36-1.32-2.04-3.21-2.04-5.67h5.07c0 1.98.75 2.97 2.25 2.97 1.3 0 1.95-.76 1.95-2.28v-14.49h5.127Z"
        onMouseEnter={() => {
          const targetRect = document.getElementById('NJB');
          if (targetRect instanceof SVGRectElement) {
            targetRect.style.fill = '#C9DAF8';
          }
        }}
        onMouseLeave={() => {
          const targetRect = document.getElementById('NJB');
          if (targetRect instanceof SVGRectElement) {
            targetRect.style.fill = '#15c';
          }
        }}
      />
      <rect
        id="RIB"
        strokeWidth={0}
        width={82}
        height={39}
        x={945}
        y={238}
        fill="#15c"
        rx={15}
        style={{
          cursor: 'pointer',
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        fill="#fff"
        strokeWidth={0}
        d="m984.66 268-4.59-8.01h-1.17V268h-5.13v-21.21h8.76c1.68 0 3.1.29 4.26.87 1.16.58 2.03 1.38 2.61 2.4.58 1 .87 2.15.87 3.45 0 1.54-.43 2.85-1.29 3.93-.84 1.08-2.07 1.82-3.69 2.22l5.04 8.34h-5.67Zm-5.76-11.52h3.18c1.02 0 1.77-.22 2.25-.66.48-.46.72-1.13.72-2.01 0-.84-.25-1.5-.75-1.98-.48-.48-1.22-.72-2.22-.72h-3.18v5.37Zm19.072-9.69V268h-5.13v-21.21h5.13Z"
      />
      <rect
        id="NHB"
        strokeWidth={0}
        width={82}
        height={39}
        x={945}
        y={185}
        fill="#15c"
        rx={15}
        style={{
          cursor: 'pointer',
          strokeWidth: 0,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        strokeWidth={0}
        fill="#fff"
        d="M983.61 217h-5.13l-8.58-13.02V217h-5.13v-21.21h5.13l8.58 13.14v-13.14h5.13V217Zm21.87-21.21V217h-5.16v-8.85h-8.037V217h-5.13v-21.21h5.13v8.22h8.037v-8.22h5.16Z"
      />
      <rect
        strokeWidth={0}
        id="DEB"
        width={82}
        height={39}
        x={1033}
        y={325}
        fill="#f9f9f9"
        rx={15}
        style={{
          cursor: 'pointer',
          strokeWidth: 0,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        fill="#fff"
        strokeWidth={0}
        d="M1075.85 344.35c0 2.08-.45 3.93-1.35 5.55-.88 1.6-2.16 2.85-3.84 3.75-1.66.9-3.62 1.35-5.88 1.35h-8.01v-21.21h8.01c2.28 0 4.25.44 5.91 1.32 1.66.88 2.93 2.12 3.81 3.72.9 1.6 1.35 3.44 1.35 5.52Zm-11.52 6.06c2 0 3.55-.53 4.65-1.59 1.12-1.06 1.68-2.55 1.68-4.47s-.56-3.41-1.68-4.47c-1.1-1.06-2.65-1.59-4.65-1.59h-2.43v12.12h2.43Zm19.57-12.54v4.44h7.17v3.87h-7.17v4.71h8.07V355h-13.2v-21.21h13.2v4.08h-8.07Z"
      />
      <rect
        id="DCB"
        strokeWidth={0}
        width={82}
        height={39}
        x={1033}
        y={377}
        fill="#f9f9f9"
        rx={15}
        style={{
          cursor: 'pointer',
          strokeWidth: 0,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        fill="#fff"
        strokeWidth={0}
        d="M1071.85 395.35c0 2.08-.45 3.93-1.35 5.55-.88 1.6-2.16 2.85-3.84 3.75-1.66.9-3.62 1.35-5.88 1.35h-8.01v-21.21h8.01c2.28 0 4.25.44 5.91 1.32 1.66.88 2.93 2.12 3.81 3.72.9 1.6 1.35 3.44 1.35 5.52Zm-11.52 6.06c2 0 3.55-.53 4.65-1.59 1.12-1.06 1.68-2.55 1.68-4.47s-.56-3.41-1.68-4.47c-1.1-1.06-2.65-1.59-4.65-1.59h-2.43v12.12h2.43Zm24.13-16.83c2.7 0 4.93.71 6.69 2.13 1.78 1.42 2.93 3.34 3.45 5.76h-5.43c-.4-.98-1.02-1.75-1.86-2.31-.82-.56-1.8-.84-2.94-.84-1.5 0-2.71.55-3.63 1.65-.92 1.1-1.38 2.57-1.38 4.41 0 1.84.46 3.31 1.38 4.41.92 1.08 2.13 1.62 3.63 1.62 1.14 0 2.12-.28 2.94-.84.84-.56 1.46-1.32 1.86-2.28h5.43c-.52 2.4-1.67 4.32-3.45 5.76-1.76 1.42-3.99 2.13-6.69 2.13-2.06 0-3.87-.45-5.43-1.35-1.56-.92-2.77-2.2-3.63-3.84-.84-1.64-1.26-3.51-1.26-5.61 0-2.1.42-3.97 1.26-5.61.86-1.64 2.07-2.91 3.63-3.81 1.56-.92 3.37-1.38 5.43-1.38Z"
      />
      <rect
        id="CTB"
        strokeWidth={0}
        width={82}
        height={39}
        x={1033}
        y={270}
        fill="#15c"
        rx={15}
        style={{
          cursor: 'pointer',
          strokeWidth: 0,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        style={{
          cursor: 'pointer',
        }}
        id="CTL"
        fill="#fff"
        strokeWidth={0}
        d="M1064.46 277.58c2.7 0 4.93.71 6.69 2.13 1.78 1.42 2.93 3.34 3.45 5.76h-5.43c-.4-.98-1.02-1.75-1.86-2.31-.82-.56-1.8-.84-2.94-.84-1.5 0-2.71.55-3.63 1.65-.92 1.1-1.38 2.57-1.38 4.41 0 1.84.46 3.31 1.38 4.41.92 1.08 2.13 1.62 3.63 1.62 1.14 0 2.12-.28 2.94-.84.84-.56 1.46-1.32 1.86-2.28h5.43c-.52 2.4-1.67 4.32-3.45 5.76-1.76 1.42-3.99 2.13-6.69 2.13-2.06 0-3.87-.45-5.43-1.35-1.56-.92-2.77-2.2-3.63-3.84-.84-1.64-1.26-3.51-1.26-5.61 0-2.1.42-3.97 1.26-5.61.86-1.64 2.07-2.91 3.63-3.81 1.56-.92 3.37-1.38 5.43-1.38Zm28.26.21v4.08h-5.76V299h-5.16v-17.13h-5.7v-4.08h16.62Z"
        onMouseEnter={() => {
          const targetRect = document.getElementById('CTB');
          if (targetRect instanceof SVGRectElement) {
            targetRect.style.fill = '#C9DAF8';
          }
        }}
        onMouseLeave={() => {
          const targetRect = document.getElementById('CTB');
          if (targetRect instanceof SVGRectElement) {
            targetRect.style.fill = '#15c';
          }
        }}
      />
      <rect
        id="MAB"
        strokeWidth={0}
        width={82}
        height={39}
        x={1033}
        y={214}
        fill="#15c"
        rx={15}
        style={{
          cursor: 'pointer',
          strokeWidth: 0,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        fill="#fff"
        strokeWidth={0}
        d="M1074.62 222.94V244h-5.13v-13.17l-4.56 13.17h-4.44l-4.59-13.2V244h-5.13v-21.06h6.27l5.73 14.67 5.61-14.67h6.24Zm16.68 17.19h-7.95l-1.32 3.87h-5.4l7.77-21.06h5.91l7.77 21.06h-5.46l-1.32-3.87Zm-1.32-3.9-2.64-7.8-2.67 7.8h5.31Z"
      />
      <rect
        id="VTB"
        strokeWidth={0}
        width={82}
        height={39}
        x={1033}
        y={161}
        fill="#15c"
        rx={15}
        style={{
          cursor: 'pointer',
          strokeWidth: 0,
          fill: '#15c',
        }}
        onMouseEnter={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#C9DAF8';
        }}
        onMouseLeave={(e) => {
          const target = e.target as SVGPathElement;
          target.style.fill = '#15c';
        }}
      />
      <path
        fill="#fff"
        strokeWidth={0}
        d="m1060.73 171.79 5.19 15.96 5.19-15.96h5.49l-7.38 21.21h-6.63l-7.35-21.21h5.49Zm33.08 0v4.08h-5.76V193h-5.16v-17.13h-5.7v-4.08h16.62Z"
      />
    </svg>
  );
};
